import { motion } from "framer-motion";
import { IMAGES } from "../../lib/constants";

const STEPS = [
  {
    num: "01",
    title: "Kapcsolatfelvétel",
    desc: "Töltse ki az űrlapot vagy hívjon minket telefonon – akár hétvégén is.",
    img: IMAGES.process1,
    alt: "Elhelyezkedő lom egy ház előtt",
    testid: "step-contact",
  },
  {
    num: "02",
    title: "Ingyenes Becslés",
    desc: "Fotó alapján vagy helyszíni felméréssel fix árat adunk – rejtett költségek nélkül.",
    img: IMAGES.process2,
    alt: "Szállító jármű érkezik a helyszínre",
    testid: "step-estimate",
  },
  {
    num: "03",
    title: "Gyors Elszállítás",
    desc: "Megbeszélt időpontban elszállítjuk a hulladékot, és tisztán adjuk át a területet.",
    img: IMAGES.process3,
    alt: "Tiszta, kiürített, napfényes szoba",
    testid: "step-removal",
  },
];

export default function Process() {
  return (
    <section id="folyamat" data-testid="process-section" className="py-24 lg:py-32 bg-white border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#16A34A] mb-4">02 / Hogyan működik?</p>
          <h2 className="font-display font-black tracking-tighter text-[#1E293B] text-4xl sm:text-5xl">
            3 egyszerű lépés.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {STEPS.map(({ num, title, desc, img, alt, testid }, i) => (
            <motion.div
              key={testid}
              data-testid={testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="group"
            >
              <div className="relative rounded-3xl overflow-hidden mb-6 shadow-lg shadow-slate-900/8">
                <img
                  src={img}
                  alt={alt}
                  loading="lazy"
                  className="w-full h-56 lg:h-64 object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 bg-[#16A34A] text-white font-display font-black text-sm px-4 py-2 rounded-full shadow-lg">
                  {num}
                </span>
              </div>
              <h3 className="font-display font-extrabold text-[#1E293B] text-xl lg:text-2xl tracking-tight mb-2">
                {title}
              </h3>
              <p className="text-sm md:text-base text-[#64748B] leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
